module.exports = __webpack_public_path__ + "img/head-shoulders.780a9c82.png";